/**
 * Common API fetch wrapper with CSRF protection.
 * All client-side API calls should use this instead of raw fetch().
 */
export async function apiClient(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  const headers = new Headers(options.headers);
  headers.set("X-Requested-With", "XMLHttpRequest");

  return fetch(url, {
    ...options,
    headers,
  });
}
